import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-emerald-50 via-green-50 to-teal-50 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Section */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center space-x-3 group">
              <div className="w-12 h-12 bg-gradient-primary rounded-xl flex items-center justify-center shadow-lg group-hover:shadow-glow transition-all duration-300">
                <span className="text-2xl font-bold text-white font-display">Y</span>
              </div>
              <div className="flex flex-col">
                <span className="text-xl font-bold bg-gradient-primary bg-clip-text text-transparent font-display">
                  Yono Rummy
                </span>
                <span className="text-xs text-gray-600 font-medium">Premier Rummy Platform</span>
              </div>
            </Link>
            <p className="text-sm text-gray-600 leading-relaxed">
              Your trusted destination for the best Indian rummy games. Download, play, and win real money with secure and fair gameplay.
            </p>
            <div className="flex space-x-3">
              <a href="#" className="w-10 h-10 bg-white rounded-lg flex items-center justify-center text-primary-600 hover:bg-gradient-primary hover:text-white transition-all duration-300 shadow-sm hover:shadow-md cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white rounded-lg flex items-center justify-center text-primary-600 hover:bg-gradient-primary hover:text-white transition-all duration-300 shadow-sm hover:shadow-md cursor-pointer">
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white rounded-lg flex items-center justify-center text-primary-600 hover:bg-gradient-primary hover:text-white transition-all duration-300 shadow-sm hover:shadow-md cursor-pointer">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white rounded-lg flex items-center justify-center text-primary-600 hover:bg-gradient-primary hover:text-white transition-all duration-300 shadow-sm hover:shadow-md cursor-pointer">
                <i className="ri-youtube-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-base font-bold text-gray-900 mb-4 font-display">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-gray-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/games" className="text-sm text-gray-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer">
                  All Games
                </Link>
              </li>
              <li>
                <a href="#features" className="text-sm text-gray-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer">
                  Features
                </a>
              </li>
              <li>
                <a href="#about" className="text-sm text-gray-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer">
                  About Us
                </a>
              </li>
            </ul>
          </div>

          {/* Game Categories */}
          <div>
            <h3 className="text-base font-bold text-gray-900 mb-4 font-display">Game Categories</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/games" className="text-sm text-gray-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer">
                  Rummy Games
                </Link>
              </li>
              <li>
                <Link to="/games" className="text-sm text-gray-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer">
                  Casino Games
                </Link>
              </li>
              <li>
                <Link to="/games" className="text-sm text-gray-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer">
                  Slots Games
                </Link>
              </li>
              <li>
                <Link to="/games" className="text-sm text-gray-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer">
                  Card Games
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-base font-bold text-gray-900 mb-4 font-display">Support</h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-sm text-gray-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer">
                  Help Center
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-600">
              © 2026 Yono Rummy. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-sm text-gray-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer">
                Responsible Gaming
              </a>
              <a href="#" className="text-sm text-gray-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer">
                18+ Only
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
